import { useMemo } from 'react';


/**
 * List of browsers that exist in the world. E.g. Chrome/Edge/IE/FF...
 */
export enum BROWSER {
  IE11,
  EDGE,
  FIRE_FOX,
  CHROME,
  SAFARI,
  UNKNOWN,
}


export type BrowserSetting = {
  currentBrowser: BROWSER;
  onFirefox: boolean;
  onIe: boolean;
  onEdge: boolean;
  onChrome: boolean;
  onSafari: boolean;
};


/**
 * Parses a user agent string to figure out which browser the user is using.
 */
export const parseUserAgent = (agent: string): BROWSER => {
  /* The order matters! Many browsers declare compatibility with Chrome/Safari by listing it in the user agent e.g. */
  if (agent.indexOf('Firefox') > 0) {
    return BROWSER.FIRE_FOX; // Unique
  }

  if (agent.indexOf('Trident/') > 0) {
    return BROWSER.IE11; // Unique
  }

  if (agent.indexOf('Edge/') > 0) {
    return BROWSER.EDGE; // Unique
  }

  if (agent.indexOf('Chrome') > 0) {
    return BROWSER.CHROME; // Very not unique
  }

  if (agent.indexOf('Safari') > 0) {
    return BROWSER.SAFARI; // Chrome inexplicably has Safari in its agent string
  }

  return BROWSER.UNKNOWN;
};


export const getCurrentBrowser = (agent: string): BrowserSetting => {
  const userAgent = parseUserAgent(agent);

  return ({
    currentBrowser: userAgent,
    onFirefox:      userAgent === BROWSER.FIRE_FOX,
    onIe:           userAgent === BROWSER.IE11,
    onEdge:         userAgent === BROWSER.EDGE,
    onChrome:       userAgent === BROWSER.CHROME,
    onSafari:       userAgent === BROWSER.SAFARI,
  });
};


export const useBrowser = () => useMemo(() => getCurrentBrowser(window.navigator.userAgent), []);